// @flow
import React, { useContext } from 'react';

import { getProductBadgecolor } from 'Components/utils/product/product.utils';
import { messageFormat } from '@clubmed/utils';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductMustTryLarge } from 'Components/widgets/product-must-try/ProductMustTryLarge';
import { ProductMustTryNarrow } from 'Components/widgets/product-must-try/ProductMustTryNarrow';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

type Props = {|
  config: CMSContent,
  id: string,
  isFrench?: boolean,
  mustTryExperiences: Array<{
    description: string,
    id: string,
    image: string,
    title: string,
  }>,
  resort: Resort,
  seeMore: string,
  title: string,
|};

export const ProductMustTryLine = ({
  config: {
    common: { scrollBackward, scrollForward },
  },
  id,
  isFrench,
  mustTryExperiences,
  resort: { comfort, name: productName, resortId: productId, type },
  seeMore,
  title = '',
}: Props) => {
  const items = mustTryExperiences.map(({ id: itemId, title: itemTitle, image, description }) => ({
    description,
    id: itemId,
    imageSrc: image,
    seeMoreLabel: seeMore,
    title: itemTitle,
    trackingData: {
      categoryGA: 'cards',
      actionGA: 'must_try',
      labelGA: itemTitle || null,
    },
  }));

  const { isTablet } = useContext(ResponsiveContext);

  if (!items.length) {
    return null;
  }

  const props = {
    isFrench,
    items,
    productColor: getProductBadgecolor(type, comfort),
    productIconName: String(productId).toLowerCase(),
  };

  const titleNode = <LineTitle>{messageFormat(title).format({ productName })}</LineTitle>;

  return isTablet ? (
    <SiteContainer id={id} className="Line">
      {titleNode}
      <ProductMustTryLarge {...props} />
    </SiteContainer>
  ) : (
    <div {...(id ? { id } : null)} className="Line">
      {titleNode}
      <ProductMustTryNarrow
        {...props}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
      />
    </div>
  );
};
